import { render, staticRenderFns } from "./XmList.vue?vue&type=template&id=0a10de17&scoped=true"
import script from "./XmList.vue?vue&type=script&lang=js"
export * from "./XmList.vue?vue&type=script&lang=js"
import style0 from "./XmList.vue?vue&type=style&index=0&id=0a10de17&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_658dcddb1d89a08c03476f5e8f9c1110/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a10de17",
  null
  
)

export default component.exports